<div class="loader-wrapper" [class.loderhide]="!show">
  <div class="loader">
    <img src="../../../../assets/images/loader/Heart-beat.gif">
  </div>
</div>
